const ApiUrl = 'https://brilho.goldpos.com.co/apiGold/';

const ApiRaiz = 'https://brilho.goldpos.com.co/';


const BackgroundColor = '#4175CB';


export { ApiUrl, BackgroundColor,ApiRaiz }
